import React from "react";

const UsedEndMonthDay = ({ item }: any) => {
  return (
    <>
      <td className="py-2 px-4 text-left align-top">
        <p
          className={` text-white px-3 my-1 inline-block  rounded-md py-1 ${
            item.leave_type === "Annual Leave" ? "bg-green-500" : item.leave_type === "Sick Leave" ? "bg-[#a657f6]" : "bg-red-700"
          } font-semibold text-sm  line-clamp-1`}
        >
          {item.leave_type.replace(/-/g, " ")}
        </p>
        <p className="font-bold  text-[15px]  text-yellow-500  ">{item.no_of_day > 0 ? item.no_of_day + " days" : ""} </p>
      </td>
      {["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].map((month, monthIndex) => (
        <td key={month} className="py-2 px-4  text-[15px] text-nowrap text-end align-top">
          <p className="text-[15px] font-semibold text-nowrap ">{item[`${month}_used_day`] !== "0.000" ? <p className="text-red-500">{item[`${month}_used_day`]}</p> : "-"}</p>
          <p className="text-[15px] font-semibold text-nowrap ">{item[`${month}_end_day`] !== "0.000" ? <p className="text-blue-500">{item[`${month}_end_day`]}</p> : "-"}</p>
        </td>
      ))}
    </>
  );
};

export default UsedEndMonthDay;
